const notification = {
  content: {
    label: "Content",
  },
};

export default notification;
